
//converts signID to Sign Index ID
export function signId2ArrayId(signID: number | string) {
  let signArrayId;
    switch (signID) {
      case "1":
          signArrayId="0";
        return signArrayId;
        // break;

      case "2":
          signArrayId="1";
        return signArrayId;
        // break;

      case "3":
          signArrayId="2";
        return signArrayId;

        // break;
      case "4":
          signArrayId="3";
        return signArrayId;

        // break;
      case "5":
          signArrayId="4";
        return signArrayId;

        // break;
      case "6":
          signArrayId="5";
        return signArrayId;

        // break;
      case "7":
          signArrayId="6";
        return signArrayId;

        // break;
      case "8":
          signArrayId="7";
        return signArrayId;

        // break;
      case "9":
          signArrayId="8";
        return signArrayId;

        // break;
      case "10":
          signArrayId="9";
        return signArrayId;

        // break;
      case "11":
          signArrayId="10";
        return signArrayId;

        // break;

      case "12":
          signArrayId="11";
        return signArrayId;

        // break;

      case 1:
          signArrayId="0";
        return signArrayId;
        // break;

      case 2:
          signArrayId="1";
        return signArrayId;
        // break;

      case 3:
          signArrayId="2";
        return signArrayId;

        // break;
      case 4:
          signArrayId="3";
        return signArrayId;

        // break;
      case 5:
          signArrayId="4";
        return signArrayId;

        // break;
      case 6:
          signArrayId="5";
        return signArrayId;

        // break;
      case 7:
          signArrayId="6";
        return signArrayId;

        // break;
      case 8:
          signArrayId="7";
        return signArrayId;

        // break;
      case 9:
          signArrayId="8";
        return signArrayId;

        // break;
      case 10:
          signArrayId="9";
        return signArrayId;

        // break;
      case 11:
          signArrayId="10";
        return signArrayId;

        // break;

      case 12:
          signArrayId="11";
        return signArrayId;

        // break;


      default:
          
        return 'undefined ID to convert' ;
        // break;
    }
}

  //Converts Month ID to Month Index Number
  export function monthId2ArrayId(monthID: number | string) {
    let monthArrayId;
      switch (monthID) {
        case "1":
            monthArrayId=0;
          return monthArrayId;
          // break;
  
        case "2":
            monthArrayId=1;
          return monthArrayId;
          // break;
  
        case "3":
            monthArrayId=2;
          return monthArrayId;
  
          // break;
        case "4":
            monthArrayId=3;
          return monthArrayId;
  
          // break;
        case "5":
            monthArrayId=4;
          return monthArrayId;
  
          // break;
        case "6":
            monthArrayId=5;
          return monthArrayId;
  
          // break;
        case "7":
            monthArrayId=6;
          return monthArrayId;
  
          // break;
        case "8":
            monthArrayId=7;
          return monthArrayId;
  
          // break;
        case "9":
            monthArrayId=8;
          return monthArrayId;
  
          // break;
        case "10":
            monthArrayId=9;
          return monthArrayId;
  
          // break;
        case "11":
            monthArrayId=10;
          return monthArrayId;
  
          // break;
  
        case "12":
            monthArrayId=11;
          return monthArrayId;
  
          // break;
  
        case 1:
            monthArrayId=0;
          return monthArrayId;
          // break;
  
        case 2:
            monthArrayId=1;
          return monthArrayId;
          // break;
  
        case 3:
            monthArrayId=2;
          return monthArrayId;
  
          // break;
        case 4:
            monthArrayId=3;
          return monthArrayId;
  
          // break;
        case 5:
            monthArrayId=4;
          return monthArrayId;
  
          // break;
        case 6:
            monthArrayId=5;
          return monthArrayId;
  
          // break;
        case 7:
            monthArrayId=6;
          return monthArrayId;
  
          // break;
        case 8:
            monthArrayId=7;
          return monthArrayId;
  
          // break;
        case 9:
            monthArrayId=8;
          return monthArrayId;
  
          // break;
        case 10:
            monthArrayId=9;
          return monthArrayId;
  
          // break;
        case 11:
            monthArrayId=10;
          return monthArrayId;
  
          // break;
  
        case 12:
            monthArrayId=11;
          return monthArrayId;
  
          // break;
  
  
        default:
            
          return 'undefined ID to convert' ;
          // break;
      }
    }
  

    //Month to Array ID 
 export function monthName2ArrayIndex(monthName: number | string) {
    let monthArrayIdIndex;
    // exports.monthArrayIdIndex = (monthName) => {
        switch (monthName) {
          case "January":
              monthArrayIdIndex=0;
            return monthArrayIdIndex;
            // break;
    
          case "February":
              monthArrayIdIndex=1;
            return monthArrayIdIndex;
            // break;
    
          case "March":
              monthArrayIdIndex=2;
            return monthArrayIdIndex;
    
            // break;
          case "April":
              monthArrayIdIndex=3;
            return monthArrayIdIndex;
    
            // break;
          case "May":
              monthArrayIdIndex=4;
            return monthArrayIdIndex;
    
            // break;
          case "June":
              monthArrayIdIndex=5;
            return monthArrayIdIndex;
    
            // break;
          case "July":
              monthArrayIdIndex=6;
            return monthArrayIdIndex;
    
            // break;
          case "August":
              monthArrayIdIndex=7;
            return monthArrayIdIndex;
    
            // break;
          case "September":
              monthArrayIdIndex=8;
            return monthArrayIdIndex;
    
            // break;
            case "October":
              monthArrayIdIndex=9;
            return monthArrayIdIndex;
    
            // break;
          case "November":
              monthArrayIdIndex=10;
            return monthArrayIdIndex;
    
            // break;
          case "December":
              monthArrayIdIndex=11;
            return monthArrayIdIndex;

              case "Jan":
                  monthArrayIdIndex=0;
                return monthArrayIdIndex;
                // break;
        
              case "Feb":
                  monthArrayIdIndex=1;
                return monthArrayIdIndex;
                // break;
        
              case "Mar":
                  monthArrayIdIndex=2;
                return monthArrayIdIndex;
        
                // break;
              case "Apr":
                  monthArrayIdIndex=3;
                return monthArrayIdIndex;
        
                // break;
              case "May":
                  monthArrayIdIndex=4;
                return monthArrayIdIndex;
        
                // break;
              case "Jun":
                  monthArrayIdIndex=5;
                return monthArrayIdIndex;
        
                // break;
              case "Jul":
                  monthArrayIdIndex=6;
                return monthArrayIdIndex;
        
                // break;
              case "Aug":
                  monthArrayIdIndex=7;
                return monthArrayIdIndex;
        
                // break;
              case "Sept":
                  monthArrayIdIndex=8;
                return monthArrayIdIndex;
        
                // break;
                case "Oct":
                  monthArrayIdIndex=9;
                return monthArrayIdIndex;
        
                // break;
              case "Nov":
                  monthArrayIdIndex=10;
                return monthArrayIdIndex;
        
                // break;
              case "Dec":
                  monthArrayIdIndex=11;
                return monthArrayIdIndex;            
            // break;
          default:
          
    
            return "invalid month name";
            // break;
        }
      }
//Converts Sign ID to starting Month Array ID Number
   export function signId2MonthArrayId(monthID: number | string) {
    let monthArrayId;
      switch (monthID) {
        case "1":
            monthArrayId=2;
          return monthArrayId;
          // break;
  
        case "2":
            monthArrayId=3;
          return monthArrayId;
          // break;
  
        case "3":
            monthArrayId=4;
          return monthArrayId;
  
          // break;
        case "4":
            monthArrayId=5;
          return monthArrayId;
  
          // break;
        case "5":
            monthArrayId=6;
          return monthArrayId;
  
          // break;
        case "6":
            monthArrayId=7;
          return monthArrayId;
  
          // break;
        case "7":
            monthArrayId=8;
          return monthArrayId;
  
          // break;
        case "8":
            monthArrayId=9;
          return monthArrayId;
  
          // break;
        case "9":
            monthArrayId=10;
          return monthArrayId;
  
          // break;
        case "10":
            monthArrayId=11;
          return monthArrayId;
  
          // break;
        case "11":
            monthArrayId=0;
          return monthArrayId;
  
          // break;
  
        case "12":
            monthArrayId=1;
          return monthArrayId;
  
          // break;
  
        case 1:
            monthArrayId=2;
          return monthArrayId;
          // break;
  
        case 2:
            monthArrayId=3;
          return monthArrayId;
          // break;
  
        case 3:
            monthArrayId=4;
          return monthArrayId;
  
          // break;
        case 4:
            monthArrayId=5;
          return monthArrayId;
  
          // break;
        case 5:
            monthArrayId=6;
          return monthArrayId;
  
          // break;
        case 6:
            monthArrayId=7;
          return monthArrayId;
  
          // break;
        case 7:
            monthArrayId=8;
          return monthArrayId;
  
          // break;
        case 8:
            monthArrayId=9;
          return monthArrayId;
  
          // break;
        case 9:
            monthArrayId=10;
          return monthArrayId;
  
          // break;
        case 10:
            monthArrayId=11
          return monthArrayId;
  
          // break;
        case 11:
            monthArrayId=0;
          return monthArrayId;
  
          // break;
  
        case 12:
            monthArrayId=1;
          return monthArrayId;
  
          // break;
  
  
        default:
            
          return 'undefined ID to convert' ;
          // break;
      }
    }